// extracted by mini-css-extract-plugin
export default {"dotsTyping":"LoadingPageTransition_dotsTyping__sGKPL","bouncingDots":"LoadingPageTransition_bouncingDots__AVLQt"};